import type { ExperimentStatus } from "@globals";

const experimentStatusFormatMap: Record<ExperimentStatus, string> = {
  draft: "Draft",
  created: "Ready",
  configuration_changed: "Changed",
  recommending: "Recommending",
  waiting: "Ready",
  stopped: "Stopped",
  error: "Error",
  retraining: "Retraining",
  retraining_error: "Retraining Error"
};

/**
 * Formats the experiment status to a human-readable string.
 */
export default function formatExperimentStatus(status: ExperimentStatus): string {
  return experimentStatusFormatMap[status];
}
